import SlidingDrawer from './SlidingDrawer';

export default SlidingDrawer;
